import { backendUrl } from '../lib/config';

export const makeGetRequest = url => {
	return fetch(`${backendUrl}/${url}`, {
		method: 'GET',
	});
};

export const makeRequest = (url, requestData) => {
	const headers = {
		'Content-Type': 'application/json',
	};
	const body = JSON.stringify(requestData);
	return fetch(`${backendUrl}/${url}`, {
		method: 'POST',
		headers,
		body,
	}).then(response => {
		if (response.status === 401) {
			throw new Error('Недействительные учетные данные');
		}
		return response.json();
	});
};



// WEBPACK FOOTER //
// src/util/http-client.js